<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Periode KPI' }" isRouteLink>Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton>Simpan</ArgonButton>
                    <ArgonButton :to="{ name: 'Periode KPI' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Periode Penilaian"
                description="Pastikan periode penilaian diisi sesuai dengan periode yang Anda laporkan">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama" idinput="name" invalidmsg="Harus di isi">
                    <InputForm v-model="data.name" type="text" idinput="name" name="name" placeholder="Nama Periode" :isinvalid="!this.validate(/.+/, data.name)" />
                  </form-group>

                  <form-group label="Tahun Periode" idinput="year" invalidmsg="Tahun tidak valid (YYYY)">
                    <InputForm type="number" idinput="year" name="year" min="1000" max="9999" placeholder="Silahkan pilih tahun" v-model="data.year" :isinvalid="!this.validate(/^[0-9]{4}$/, data.year)" />
                  </form-group>

                  <form-group label="Jenis Penilaian" hint="Contoh, Tahunan, Quarter atau semester">
                    <select-form style="text-transform: capitalize;" name="type" idinput="type" v-model="data.type" :options="['quarter', 'semester', 'tahunan']" />
                  </form-group>

                  <form-group label="Periode Penilaian" idinput="weight">
                    <VueDatePicker @update:model-value="changePeriode" v-model="rangePeriode" :enable-time-picker="false" :range="true" />
                  </form-group>
                  <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="active" v-model="data.status" name="status"
                        id="status_0" autocomplete="off">
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="inactive" v-model="data.status" name="status"
                        id="status_1" autocomplete="off">
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import JabatanApi from "@/repository/api/JabatanApi";
import RealisasiKpiApi from "@/repository/api/RealisasiKpiApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
// import InputGroup from "@/components/InputGroup.vue";
// import Avatar from "@/components/Avatar.vue";
import ArgonButton from "@/components/ArgonButton.vue"
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputForm from "@/components/InputForm.vue";
import SelectForm from "@/components/SelectForm.vue";


export default {
  name: "profile",
  data() {
    return {
      rangePeriode: "",
      showMenu: false,
      data: {},
      unitKerja: [
        {}
      ],
      employee: [{}],
      selectedEmployeeAdd: "",
      optionEmployee: [
        {
          id: "abc",
          text: "xyz",
        },
      ],
      jabatan: [],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: '',
      validated: false,
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    // Select2,
    // InputGroup,
    // Avatar,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    InputForm,
    SelectForm,
  },
  watch: {
    "data": {
      handler: function (newVal) {
        this.rangePeriode = [(newVal?.start ?? ""), (newVal?.end ?? "")]
      },
      deep: true,
    },
  },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
    else {
      this.data.year = new Date().getFullYear()
    }
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip();
  },
  methods: {
    validate(pattern, str) {
      if (pattern.test(str) === true) {
        this.validated = true;
        return true;
      }
      else {
        this.validated = false;
        return false;
      }
    },
    format(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${year}/${month}/${day}`;
    },
    changePeriode(value) {
      console.log(String(value[0].getDate()).padStart(2, '0'))
      this.data.start = [String(value[0].getFullYear()).padStart(4, '0'),String(value[0].getMonth()+1).padStart(2, '0'),String(value[0].getDate()).padStart(2, '0')].join("-");
      this.data.end = [String(value[1].getFullYear()).padStart(4, '0'),String(value[1].getMonth()+1).padStart(2, '0'),String(value[1].getDate()).padStart(2, '0')].join("-");
    },
    async unassignKpi(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        text: "Jika anda unassign pegawai maka progress pegawai tersebut untuk kpi terkait akan ikut dihapus",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await RealisasiKpiApi.delete(id).then(async () => {
            this.$swal({
              icon: "success",
              title: "Berhasil Unassign"
            })
            await this.getRealisasi();
          })
          this.$store.state.loading = false;
        }
      });
    },
    async getRealisasi() {
      this.$store.state.loading = true;
      await RealisasiKpiApi.getbyparam({ kpi_id: this.$route.params.id }).then((response) => {
        this.data.realisations = response.data
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      })
      this.$store.state.loading = false;
    },
    async assignEmployee(data) {
      this.$store.state.loading = true;
      this.selectedEmployeeAdd = data.id;
      await RealisasiKpiApi.post({
        employee_id: this.selectedEmployeeAdd,
        kpi_id: this.$route.params.id
      }).then(async () => {
        this.$swal({
          icon: "success",
          text: "Assigned"
        })
        await this.getRealisasi();
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      });
      this.$store.state.loading = false;
    },
    getSelectedUnitKerja() {
      return this.unitKerja.find((item) => {
        return item.id == this.data.unit_kerja_id;
      });
    },
    async getOptionUnitKerja() {
      this.optionUnitKerja = this.unitKerja.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.get().then(async (response) => {
        this.unitKerja = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "Belum ada unit kerja"
        });
      });
      await this.getOptionUnitKerja();
      this.$store.state.loading = false;
    },
    async getOptionJabatan() {
      this.optionJabatan = this.jabatan.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.get().then((response) => {
        this.jabatan = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "Belum ada jabatan"
        });
      });
      await this.getOptionJabatan();
      this.$store.state.loading = false;
    },
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text })
    },
    async submit() {
      this.$store.state.loading = true;
      if (this.$route.params.id) {
        await KpiPeriodeApi.update(this.$route.params.id, this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Periode KPI" });
          })
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message ?? "",
          });
        });
      }
      else {
        await KpiPeriodeApi.post(this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Periode KPI" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await KpiPeriodeApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
        this.data.start = this.data.start.split("T")[0];
        this.data.end = this.data.end.split("T")[0];
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Periode KPI" });
        });
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
